// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockTitle__sOAHD {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 20px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__I0VWz {
  position: relative;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.equipmentTable__ryvRz {
  width: 100%;
}
.equipmentTable__ryvRz thead {
  background-color: var(--tables-title-surface);
}
.equipmentTable__ryvRz th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-title-text);
  text-transform: uppercase;
  text-align: left;
  min-width: 130px;
  padding: 15px;
  border-top: 1px solid var(--tables-primary-row-stroke);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  position: sticky;
  top: 0;
}
.equipmentTable__ryvRz th:first-child {
  padding-left: 25px;
}
@media (max-width: 1400px) {
  .equipmentTable__ryvRz th {
    min-width: none;
  }
}
.equipmentTable__ryvRz tr:hover {
  background-color: var(--tables-primary-row-surface-hover);
}
.equipmentTable__ryvRz td {
  font-size: 14px;
  line-height: 17px;
  color: var(--tables-primary-row-text-main);
  padding: 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
.equipmentTable__ryvRz td:first-child {
  padding-left: 25px;
}

.cellEquipmentName__QumOR {
  width: 400px;
  color: var(--buttons-surface) !important;
  cursor: pointer;
}

.skeletonText__pb1Hi {
  height: 17px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/EquipmentDetails/components/EquipmentAssociated/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,2DAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,WAAA;AAzEF;AA2EE;EACE,6CAAA;AAzEJ;AA4EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sDAAA;EACA,yDAAA;EACA,gBAAA;EACA,MAAA;AA1EJ;AA4EI;EACE,kBAAA;AA1EN;AA6EI;EAlBF;IAmBI,eAAA;EA1EJ;AACF;AA8EI;EACE,yDAAA;AA5EN;AAgFE;EACE,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,yDAAA;AA9EJ;AAgFI;EACE,kBAAA;AA9EN;;AAmFA;EACE,YAAA;EACA,wCAAA;EACA,eAAA;AAhFF;;AAmFA;EACE,YAAA;AAhFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  position: relative;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.equipmentTable {\n  width: 100%;\n\n  thead {\n    background-color: var(--tables-title-surface);\n  }\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    color: var(--tables-title-text);\n    text-transform: uppercase;\n    text-align: left;\n    min-width: 130px;\n    padding: 15px;\n    border-top: 1px solid var(--tables-primary-row-stroke);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    position: sticky;\n    top: 0;\n\n    &:first-child {\n      padding-left: 25px;\n    }\n\n    @media (max-width: 1400px) {\n      min-width: none;\n    }\n  }\n\n  tr {\n    &:hover {\n      background-color: var(--tables-primary-row-surface-hover);\n    }\n  }\n\n  td {\n    font-size: 14px;\n    line-height: 17px;\n    color: var(--tables-primary-row-text-main);\n    padding: 15px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n    &:first-child {\n      padding-left: 25px;\n    }\n  }\n}\n\n.cellEquipmentName {\n  width: 400px;\n  color: var(--buttons-surface) !important;\n  cursor: pointer;\n}\n\n.skeletonText {\n  height: 17px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockTitle": `blockTitle__sOAHD`,
	"blockContainer": `blockContainer__I0VWz`,
	"equipmentTable": `equipmentTable__ryvRz`,
	"cellEquipmentName": `cellEquipmentName__QumOR`,
	"skeletonText": `skeletonText__pb1Hi`
};
module.exports = ___CSS_LOADER_EXPORT___;
